// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + (chunkId === 179 ? "main" : chunkId) + "." + {"179":"26ef7e21e8d603c34b32","923":"58ceed97367067fabd40"}[chunkId] + ".css";
};